import { styled, utils, theme } from 'ui/theme';

export const TopBar = {
  Cta: styled.div`
    ${utils.alignX}
    ${utils.flexbox.direction.row};
    flex-grow: 0;

    & button {
      font-size: ${theme.fontSizes.md};
    }

    & svg {
      margin-right: 0;
    }
  `,

  Content: styled.div`
    ${utils.alignX};
    ${utils.flexbox.direction.row};
    ${utils.flexbox.grow.grow};
  `,

  Component: styled.div`
    ${utils.flexbox.direction.row};
    background: ${theme.colors.build.lightDark2};
    padding: ${theme.space[4]};
    width: 100%;

    & button {
      color: ${theme.colors.build.darkLight};
      font-family: ${theme.fonts.primary};
      font-size: ${theme.fontSizes.sm};
      font-weight: ${theme.fontWeights.regular};
    }

    & svg {
      color: ${theme.colors.action.navigation.standard.static};
      margin-right: ${theme.space[2]};
    }

    & a {
      &[data-active='true'] {
        text-decoration: none;
      }
    }

    &[data-stretch='false'] {
      ${utils.flex.center};
      ${utils.container};
      margin-bottom: ${theme.space[4]};
      padding: 0;
    }
  `,

  Prefix: styled.div`
    ${utils.alignX}
    ${utils.flexbox.direction.row};
    ${utils.flexbox.grow.grow};
  `,

  Suffix: styled.div`
    ${utils.alignX}
    ${utils.flexbox.direction.row};
    ${utils.flexbox.grow.grow};
  `,
};
